import {Link} from "react-router-dom";
import {HOME_DEPARTMENTS} from "./homeDepartments";
import {useI18n} from "./I18nProvider";

export function DepartmentHubStrip({activeId}: {activeId: string}) {
  const {t} = useI18n();
  return (
    <section className="cc-deptHubStrip" aria-labelledby="dept-hub-strip-title">
      <h2 id="dept-hub-strip-title" className="cc-deptHubStrip__title">
        {t("Department hub all departments")}
      </h2>
      <div className="cc-deptHubStrip__grid">
        {HOME_DEPARTMENTS.map((dept) => {
          const active = dept.id === activeId;
          const soon = dept.status === "coming_soon";
          const card = (
            <div
              className={`cc-deptHubStrip__card${active ? " isActive" : ""}${soon ? " isSoon" : ""}`}
              style={{backgroundColor: dept.cardBg}}
            >
              <div className="cc-deptHubStrip__meta">
                <span className="cc-deptHubStrip__name">{t(dept.nameKey)}</span>
                {soon ? <span className="cc-deptHubStrip__badge">{t("Home departments coming soon")}</span> : null}
                {active ? <span className="cc-deptHubStrip__current">{t("Department hub current")}</span> : null}
              </div>
              <div className="cc-deptHubStrip__visualWrap">
                <img src={dept.cardImage} alt="" className="cc-deptHubStrip__img" loading="lazy" decoding="async" />
              </div>
            </div>
          );
          if(active) {
            return (
              <div key={dept.id} className="cc-deptHubStrip__item cc-deptHubStrip__item--active" aria-current="page">
                {card}
              </div>
            );
          }
          if(dept.hubPath && !soon) {
            return (
              <Link key={dept.id} to={dept.hubPath} className="cc-deptHubStrip__item anim">
                {card}
              </Link>
            );
          }
          return (
            <div key={dept.id} className="cc-deptHubStrip__item cc-deptHubStrip__item--static">
              {card}
            </div>
          );
        })}
      </div>
    </section>
  );
}
